const stylesBase = [
  {
    icon: 'lamp.svg', value: 'modern', label: { en: 'Modern', ru: 'Модерн' }, checked: true,
  },
  { icon: 'snowflake.svg', value: 'scandy', label: { en: 'Scandy', ru: 'Сканди' } },
  { icon: 'leaf.svg', value: 'boho', label: { en: 'Boho', ru: 'Бохо' } },
  { icon: 'coffee.svg', value: 'england', label: { en: 'England', ru: 'Англия' } },
  { icon: 'star.svg', value: 'zero', label: { en: 'Neutral', ru: 'Нейтральный' } },
  { icon: 'mountain.svg', value: 'japandi', label: { en: 'Japandi', ru: 'Джапанди' } },
  { icon: 'crown.svg', value: 'elegance', label: { en: 'Elegance', ru: 'Элеганс' } },
  { icon: 'star5.svg', value: 'american', label: { en: 'American', ru: 'Урбан' } },
  { icon: 'lamp.svg', value: 'contemporary', label: { en: 'Contemporary', ru: 'Современный' } },
];

// TODO: peace of sh
export const defaultStyle = stylesBase.find((data) => data.checked)?.value ?? stylesBase[0].value;
export const styleOptions = {
  en: stylesBase.map((data) => ({
    icon: data.icon,
    value: data.value,
    label: data.label.en,
  })),
  ru: stylesBase.map((data) => ({
    icon: data.icon,
    value: data.value,
    label: data.label.ru,
  })),
};

export const getStyles = (lang = 'en') => stylesBase.map(({ label, ...rest }) => ({
  ...rest,
  name: label?.[lang] || label?.en || rest.value,
}));

export const styles = getStyles('en');
